import GenericAjaxService from './GenericAjaxService';
import {privateAPI, publicAPI} from './api';
import moment from 'moment-timezone';

export default class UserService extends GenericAjaxService {

  static getUser() {
    const timezone = moment.tz.guess();
    return super.getAPI(privateAPI, `user?zoneId=${timezone}`);
  }

  static createUser(user, opts) {
    return super.postAPI(publicAPI, `register`, user, opts);
  }

  static updateUser(user) {
    return super.postAPI(privateAPI, `user`, user);
  }

  static isAdmin(user) {
    return user.role === 'Admin' || user.role === 'SuperAdmin';
  }

  static isSuperAdmin(user){
    return user.role === 'SuperAdmin';
  }
}